import { ArrowDownRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full h-[100svh] min-h-[640px] overflow-hidden bg-black"
    >
      {/* Hero background video */}
      <video
        data-testid="hero-video"
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source
          src="/gallery/hero-reel.mp4"
          type="video/mp4"
        />
      </video>

      {/* Dark contrast layer */}
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/70"
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0.35) 70%, rgba(0,0,0,0.55) 100%)",
        }}
      />

      {/* Centered content */}
      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center px-6 md:px-10 text-center">
        <h1
          data-testid="hero-headline"
          className="font-serif-display text-white text-[22px] sm:text-[26px] md:text-[30px] lg:text-[36px] xl:text-[40px] leading-[1.15] tracking-[-0.005em] md:whitespace-nowrap fade-up"
          style={{ animationDelay: "180ms" }}
        >
          Content made to be{" "}
          <span className="italic-display text-[#c9a878]">easy.</span>{" "}
          Brands made to be{" "}
          <span className="italic-display text-[#c9a878]">unforgettable.</span>
        </h1>

        <div
          className="mt-7 md:mt-9 flex flex-col sm:flex-row items-center gap-3 fade-up"
          style={{ animationDelay: "320ms" }}
        >
          <a
            href="https://portal.structuremedia.me/book"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-book-cta"
            className="group inline-flex items-center justify-between gap-3 bg-white text-black px-5 py-2.5 text-[10px] tracking-[0.22em] uppercase font-medium hover:bg-[#c9a878] hover:text-black transition-colors duration-300"
          >
            Book a shoot
            <ArrowDownRight
              size={14}
              className="transition-transform duration-500 group-hover:rotate-[-45deg]"
            />
          </a>
          <a
            href="#packages"
            data-testid="hero-learnmore-cta"
            className="inline-flex items-center justify-between gap-3 border border-white/70 text-white px-5 py-2.5 text-[10px] tracking-[0.22em] uppercase font-medium hover:bg-white hover:text-black transition-colors duration-300"
          >
            View packages
            <span aria-hidden>↘</span>
          </a>
        </div>
      </div>
    </section>
  );
}
